import React from 'react';
import Section from './Section';
import Button from './Button';

const HeroSection = ({ 
  title, 
  description, 
  buttonText = null, 
  buttonLink = null, 
  buttonVariant = "primary",
  buttonIcon = null,
  secondButtonText = null,
  secondButtonLink = null,
  secondButtonVariant = "secondary",
  centered = true,
  paddingY = "py-32", // Default changed to py-32 for consistency
  buttonScrollTo = null,
  secondButtonScrollTo = null,
  children
}) => {
  return (
    <Section background="gradient" paddingY={paddingY} className="min-h-[600px] flex items-center">
      <div className="flex flex-col md:flex-row items-center md:items-center justify-between">
        <div className={`${children ? 'md:w-1/2 mb-12 md:mb-0' : 'max-w-4xl'} ${centered && !children ? 'mx-auto text-center' : ''} flex flex-col justify-center` }>
          <h1 className="text-4xl md:text-5xl font-bold text-primary mb-6 leading-tight">
            {title}
          </h1>
          <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed max-w-xl min-h-[80px]">
            {description}
          </p>
          {buttonText && (
            <div className={`flex flex-col sm:flex-row ${centered && !children ? 'justify-center items-center' : 'justify-start'} space-y-4 sm:space-y-0 sm:space-x-4`}>
              <Button 
                to={buttonLink}
                variant={buttonVariant}
                size="lg"
                icon={buttonIcon}
                scrollTo={buttonScrollTo}
                className={centered && !children ? "mx-auto sm:mx-0" : ""}
              >
                {buttonText}
              </Button>
              {secondButtonText && (
                <Button
                  to={secondButtonLink}
                  variant={secondButtonVariant}
                  size="lg"
                  scrollTo={secondButtonScrollTo}
                  className={centered && !children ? "mx-auto sm:mx-0" : ""}
                >
                  {secondButtonText}
                </Button>
              )}
            </div>
          )}
        </div>
        {children}
      </div>
    </Section>
  );
};

export default HeroSection;